import React, { useRef, useEffect } from "react";

export function useHorizontalScroll() {
  const elementRef = useRef<any>();

  useEffect(() => {
    const el = elementRef.current;
    if (el) {
      const onWheel = (event: WheelEvent) => {
        if (event.deltaY === 0) return;
        event.preventDefault();
        el.scrollTo({
          left: el.scrollLeft + event.deltaY,
        });
      };
      el.addEventListener("wheel", onWheel);
      return () => el.removeEventListener("whell", onWheel);
    }
  }, []);
  return elementRef;
}
